import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 403 400"
        >
            <path
                fill="#BDD0FB"
                d="M359.665 236.232c-17.053.732-36.026-18.666-40.394-37.61-4.494-19.491 9.487-25.475 12.926-51.189 3.903-29.212-12.208-35.915-17.855-76.792-1.274-9.223-8.641-62.596 10.581-69.762 17.772-6.629 60.735 25.328 64.379 59.157 2.599 24.122-16.706 31.444-13.585 59.557 2.736 24.664 18.504 27.185 21.401 51.019 3.522 29.012-15.065 64.657-37.453 65.62z"
            ></path>
            <path
                fill="#91B3FA"
                d="M357.481 243.139c8.813-30.839 6.747-80.577 3.459-116.868-3.561-39.294-9.272-71.73-9.33-72.053l-1.436.18c.058.323 5.764 32.715 9.315 71.961 3.278 36.188 5.344 85.761-3.414 116.419l1.406.366v-.005z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M67.999 237.287c25.51-5.857 43.657-44.048 34.287-60.437-6.33-11.069-21.117-5.007-30.672-17.263-12.203-15.647 4.733-34.728.176-66.377C67.91 66.274 49.43 36.935 33.912 37.93 17.664 38.971.254 73.538 7.298 98.896c4.582 16.491 17.117 20.507 16.409 34.551-.82 16.296-18.128 19.325-22.11 34.297-7.16 26.892 32.657 77.29 66.402 69.538v.005z"
            ></path>
            <path
                fill="#7D97F4"
                d="M53.197 244.424a.946.946 0 001.168-1.104c-13.815-69.113-4.02-142.573-3.923-143.31a.944.944 0 10-1.87-.26c-.104.738-9.937 74.516 3.941 143.936.074.366.352.64.689.728l-.005.01z"
            ></path>
            <path
                fill="url(#paint0_linear_0_34274)"
                d="M22.32 112.383c.092.025.195.02.293-.024a.45.45 0 00.234-.596c-6.263-14.513-11.963-35.348-3.57-52.21C24.272 49.508 32 45.605 32.08 45.566a.45.45 0 00.205-.606.45.45 0 00-.606-.205c-.327.161-8.08 4.079-13.214 14.396-4.719 9.477-7.928 26.364 3.547 52.972a.456.456 0 00.303.259h.004z"
            ></path>
            <path
                fill="#7D97F4"
                d="M348.855 117.605a4.692 4.692 0 00-1.456-3.317 4.704 4.704 0 00-3.385-1.289l-101.564 3.243a4.691 4.691 0 00-4.538 4.827l5.012 168.209a4.691 4.691 0 004.734 4.552l99.521-.967a4.692 4.692 0 003.317-1.416 4.708 4.708 0 001.329-3.352l-2.97-170.485v-.005z"
            ></path>
            <g fill="#BDD0FB" opacity="0.63">
                <path d="M338.259 125.553h-90.445c-.879 0-1.587.611-1.578 1.441l.088 7.968c.01.835.733 1.778 1.617 1.778l90.704.093c.899 0 1.593-.968 1.563-1.813l-.273-8.006c-.029-.84-.777-1.461-1.671-1.461h-.005zM338.846 142.851l-90.836-.152c-.884 0-1.593.84-1.583 1.686l.088 8.069c.01.846.738 1.647 1.622 1.647l91.099.249c.904 0 1.608-.801 1.578-1.656l-.278-8.143c-.03-.85-.787-1.7-1.686-1.705l-.004.005zM339.461 161.042l-91.251-.313c-.889 0-1.602.406-1.592 1.256l.087 8.138c.01.85.738 1.495 1.627 1.5l91.495.405c.904 0 1.617-.64 1.588-1.499l-.278-8.217c-.03-.855-.777-1.275-1.681-1.28l.005.01zM340.057 178.784l-91.652-.469c-.889 0-1.607.572-1.597 1.432l.088 8.211c.01.86.738 1.344 1.631 1.349l91.901.566c.909.005 1.632-.474 1.603-1.343l-.284-8.29c-.029-.865-.786-1.456-1.69-1.46v.004zM340.658 196.678l-92.053-.625a1.604 1.604 0 00-1.602 1.607l.088 8.285c.01.87.747 1.807 1.646 1.812l92.321.733c.914.01 1.622-.928 1.593-1.807l-.284-8.363c-.029-.87-.796-1.637-1.704-1.642h-.005zM341.269 214.733l-92.463-.786c-.899-.01-1.617.913-1.607 1.788l.088 8.358c.01.874.747 1.656 1.651 1.665l92.731.894a1.598 1.598 0 001.607-1.646l-.288-8.436c-.029-.879-.806-1.822-1.719-1.832v-.005zM341.904 233.579l-92.888-.957c-.904-.01-1.632.464-1.622 1.343l.093 8.432c.01.884.752 1.499 1.656 1.509l93.146 1.065c.924.01 1.652-.596 1.617-1.485l-.288-8.515c-.029-.889-.791-1.382-1.71-1.392h-.004zM342.524 251.961l-93.303-1.128c-.908-.01-1.636.64-1.627 1.524l.093 8.505c.01.889.753 1.343 1.661 1.353l93.562 1.231c.928.01 1.661-.425 1.631-1.324l-.293-8.588c-.029-.894-.801-1.568-1.724-1.578v.005zM343.149 270.51l-93.723-1.3c-.914-.015-1.641.816-1.632 1.71l.093 8.583c.01.899.762 1.822 1.676 1.837l93.996 1.411c.933.015 1.656-.894 1.622-1.802l-.293-8.666c-.029-.904-.811-1.759-1.739-1.773z"></path>
            </g>
            <path
                fill="#7D97F4"
                d="M193.088 24.39c-.059-3.014-2.496-5.49-5.491-5.49H74.496c-3.034 0-6.009 2.608-6.009 5.661v272.913c0 1.471.84 2.877 1.871 3.913 1.03 1.036 2.565 1.617 4.02 1.612l118.256-.327c1.47 0 2.911-.601 3.942-1.661a5.63 5.63 0 001.583-4.006l-5.071-272.62v.005z"
            ></path>
            <g fill="#BDD0FB" opacity="0.81">
                <path d="M109.795 51.057l-32.222-.044-.254-16.628h32.251l.225 16.672zM145.909 51.053l-32.187-.044-.22-16.624h32.216l.191 16.668zM181.989 51.043l-32.157-.044-.186-16.614h32.187l.156 16.658zM110.195 80.91l-32.162.019-.254-16.521 32.196-.015.22 16.516zM146.251 80.885l-32.133.02-.22-16.511 32.163-.015.19 16.506zM182.263 80.86l-32.099.02-.181-16.501 32.129-.015.151 16.496zM110.596 110.552l-32.104.034-.255-16.462 32.139-.03.22 16.458zM146.588 110.512l-32.074.035-.22-16.453 32.104-.03.19 16.448zM182.541 110.478l-32.045.034-.181-16.448 32.075-.029.151 16.443zM110.996 140.095l-32.05.044-.254-16.403 32.085-.044.219 16.403zM146.925 140.042l-32.021.044-.219-16.399 32.055-.039.185 16.394zM182.815 139.988l-31.987.049-.185-16.394 32.021-.039.151 16.384zM111.397 169.532l-31.997.059-.254-16.35 32.031-.049.22 16.34zM147.262 169.464l-31.967.063-.215-16.345 31.997-.053.185 16.335zM183.089 169.4l-31.933.059-.181-16.335 31.962-.054.152 16.33zM111.792 198.871l-31.942.074-.25-16.297 31.972-.063.22 16.286zM147.594 198.788l-31.908.073-.215-16.286 31.938-.064.185 16.277zM183.362 198.705l-31.875.074-.185-16.277 31.908-.064.152 16.267zM112.188 228.108l-31.884.083-.254-16.233 31.918-.083.22 16.233zM147.931 228.01l-31.855.088-.215-16.233 31.885-.078.185 16.223zM183.636 227.912l-31.821.088-.186-16.223 31.855-.078.152 16.213zM112.584 257.242l-31.83.103-.25-16.184 31.86-.093.22 16.174zM148.264 257.134l-31.801.098-.215-16.174 31.83-.093.186 16.169zM183.909 257.022l-31.772.097-.18-16.164 31.801-.093.151 16.16zM112.975 286.278l-31.777.112-.244-16.125 31.806-.102.215 16.115zM148.595 286.156l-31.747.112-.215-16.12 31.777-.103.185 16.111zM184.177 286.029l-31.713.112-.18-16.11 31.742-.103.151 16.101z"></path>
            </g>
            <path
                fill="#91B3FA"
                d="M256.807 72.615c-.034-1.617-1.524-2.921-3.356-2.921H142.519c-1.852 0-3.82 1.343-3.82 2.984v229.227c0 1.226.781 2.399 1.763 3.263.982.865 2.423 1.349 3.81 1.349l112.149-.274c1.398 0 2.76-.503 3.737-1.387.977-.884 1.525-2.081 1.5-3.317l-4.846-228.93-.005.006z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M193.098 85.936l-36.29-.108.014-4.02 36.252.098.024 4.03zM193.195 100.747l-36.436-.151.014-4.05 36.398.137.024 4.064zM193.298 115.676l-36.588-.186.015-4.084 36.544.171.029 4.099zM193.401 130.726l-36.74-.22.01-4.118 36.701.21.029 4.128zM193.503 145.909l-36.896-.259.015-4.157 36.852.249.029 4.167zM193.709 176.65l-37.204-.337.015-4.226 37.16.327.029 4.236zM194.026 223.741l-37.678-.459.015-4.333 37.634.449.029 4.343zM193.606 161.213l-37.048-.298.015-4.186 37.003.283.03 4.201zM193.811 192.213l-37.36-.376.015-4.26 37.316.367.029 4.269zM193.919 207.909l-37.517-.415.01-4.294 37.477.405.03 4.304zM194.134 239.705l-37.839-.498.014-4.368 37.795.484.03 4.382zM194.241 255.811l-38-.542.014-4.407 37.957.528.029 4.421zM194.349 272.053l-38.167-.586.015-4.446 38.122.572.03 4.46zM194.461 288.432l-38.332-.63.014-4.479 38.284.615.034 4.494zM240.678 86.083l-36.52-.113-.039-4.03 36.476.103.083 4.04zM240.971 100.938l-36.667-.147-.039-4.07 36.627.143.079 4.074zM241.269 115.915l-36.818-.186-.039-4.098 36.778.176.079 4.108zM241.572 131.019l-36.975-.224-.039-4.133 36.931.21.083 4.147zM241.875 146.246l-37.126-.259-.044-4.167 37.086.249.084 4.177zM242.49 177.089l-37.443-.337-.039-4.24 37.399.328.083 4.249zM243.433 224.341l-37.922-.459-.044-4.347 37.878.449.088 4.357zM242.182 161.604l-37.287-.298-.039-4.206 37.243.288.083 4.216zM242.802 192.707l-37.599-.376-.044-4.28 37.556.372.087 4.284zM243.115 208.456l-37.761-.42-.044-4.309 37.722.406.083 4.323zM243.75 240.36l-38.083-.499-.044-4.386 38.039.488.088 4.397zM244.073 256.519l-38.249-.542-.044-4.426 38.205.532.088 4.436zM244.4 272.82l-38.415-.591-.044-4.46 38.371.576.088 4.475zM244.727 289.258l-38.582-.635-.044-4.499 38.538.62.088 4.514z"
            ></path>
            <path
                fill="#7D97F4"
                d="M338.992 387.504H63.964C28.636 387.504 0 358.864 0 323.541v-84.652h402.956v84.652c0 35.328-28.636 63.963-63.964 63.963z"
            ></path>
            <path
                fill="url(#paint1_linear_0_34274)"
                d="M122.378 161.326c30.656 0 55.508-24.852 55.508-55.508 0-30.656-24.852-55.508-55.508-55.508-30.656 0-55.508 24.852-55.508 55.508 0 30.656 24.852 55.508 55.508 55.508z"
            ></path>
            <path
                fill="#fff"
                d="M143.691 79.424l-5.564-7.928c-.845-1.197-2.222-1.968-3.693-1.968h-25.338c-1.466 0-2.843.771-3.693 1.968l-5.564 7.9a4.543 4.543 0 00-.235 4.865l12.819 22.607c.806 1.412 2.305 2.404 3.927 2.404h10.83c1.622 0 3.122-.982 3.928-2.394l12.818-22.544a4.622 4.622 0 00-.235-4.905v-.005zM133.814 134.884l-.914.048s-8.973 8.319-8.514 8.622c.229.152.757.591 1.221 1.002a.344.344 0 01.112.342.354.354 0 01-.244.264c-.22.063-.444.092-.664.146-.88.225-1.788.269-2.672.269-.88-.064-1.759-.132-2.565-.415-.42-.093-.786-.303-1.177-.45-.357-.205-.733-.381-1.051-.635l-.478-.366c-.157-.122-.284-.284-.425-.416-.303-.258-.503-.6-.748-.903-.21-.328-.395-.674-.566-1.026-.113-.371-.332-.752-.372-1.089l-.127-.508-.034-.128-.019-.19-.044-.386-.088-.767v-.049l-.01-.024v-.01c-.019-.132.02.166.015.132v-.073l.009-.142.01-.283v-.567l.122-.547c.035-.366.191-.713.313-1.06.083-.357.332-.679.479-1.026.21-.327.425-.659.669-.977.513-.63 1.07-1.255 1.754-1.807.649-.577 1.387-1.016 2.144-1.51.738-.483 1.627-.791 2.306-1.211l.132-.113c.698-.175 1.226-.791 1.333-1.509l.093-.63.752-4.216a4.988 4.988 0 002.331-4.221 4.934 4.934 0 00-1.036-3.033l.586-3.278h-8.27l.601 2.433a4.978 4.978 0 00-1.856 3.878c0 1.568.771 3.049 1.963 3.957l.03 2.013c.004.41-.24.781-.616.943-.327.141-.65.283-.982.478-1.001.572-1.949 1.368-2.848 2.145-.908.752-1.729 1.675-2.481 2.662-.357.513-.689 1.06-.997 1.617-.254.601-.586 1.153-.747 1.803-.186.635-.371 1.265-.42 1.929l-.108.982.034.977.025.489.014.244.01.122.02.156v.01l.01.024.009.049.157.757.078.377.039.19.073.244.313.972c.195.675.527 1.183.801 1.764.322.547.684 1.08 1.084 1.578.435.474.841.967 1.354 1.348.249.195.483.415.742.591l.801.498c.533.333 1.114.557 1.681.797.586.176 1.157.405 1.758.488 1.182.274 2.379.283 3.552.22 1.167-.132 2.315-.347 3.395-.757.268-.103.542-.191.806-.303l.776-.371.386-.186.127-.063.039-.025.083-.054.162-.102.649-.42c.45-.332.992-.757 1.392-1.163.401-.42.797-.835 1.119-1.309.694-.909 1.187-1.925 1.573-2.951.401-1.025.66-2.081.835-3.136.176-1.065.254-2.051.215-3.146l-.014-.009z"
            ></path>
            <path
                fill="url(#paint2_linear_0_34274)"
                d="M83.044 269.069l-14.166-3.835s-3.351.972-2.858 5.955c.493 4.982 14.62 4.074 14.62 4.074l2.404-6.19v-.004z"
            ></path>
            <path
                fill="url(#paint3_linear_0_34274)"
                d="M208.959 214.249c27.024 6.756 42.88 24.821 50.696 26.648 7.816 1.827 39.134 3.497 44.243 8.241 5.105 4.743.23 8.113 6.795 14.215 7.264 20.497-15.226 26.633-15.226 26.633l-204.45-1.661s-13.796 1.24-14.103-8.612c-.308-9.853 3.048-14.831 3.77-23.702.724-8.871.743-9.321 2.717-13.922 1.973-4.602 21.171-5.1 24.903-10.22 3.737-5.119 8.183-13.282 24.03-16.062 21.889-3.844 60.949-5.476 76.625-1.553v-.005z"
            ></path>
            <path
                fill="url(#paint4_linear_0_34274)"
                d="M75.814 279.126c.352 11.324 19.555 9.321 19.638 9.311 0 0 15.265-11.685-5.735-11.24-6.312-.161-12.71-3.508-12.71-3.508l-1.193 5.433v.004z"
            ></path>
            <path
                fill="url(#paint5_linear_0_34274)"
                d="M311.939 268.419s.2 2.887-5.212 5.837c-6.707 3.659-29.999-.361-29.999-.361l-2.657 14.987L296.024 290c-.513.142 28.826-1.548 15.915-21.581z"
            ></path>
            <path
                fill="url(#paint6_linear_0_34274)"
                d="M111.768 246.7s-.66-5.144 4.743-11.45c5.403-6.307 8.559-10.464 12.711-11.534 4.152-1.069 34.561-5.275 36.559-2.042 1.998 3.234 4.567 23.106 4.567 23.106l-58.585 1.92h.005z"
            ></path>
            <path
                fill="#7D97F4"
                d="M129.774 223.174c3.404-.508 29.27-3.512 35.948-2.657l1.729 6.648-55.713 19.535s-.264-4.23 2.516-8.407c4.675-7.01 11.954-14.67 15.515-15.119h.005z"
                opacity="0.23"
            ></path>
            <path
                fill="url(#paint7_linear_0_34274)"
                d="M174.877 221.669c.84 3.84 3.947 22.559 3.947 22.559l65.751-.303s-20.727-19.046-36.661-22.06c-15.935-3.014-33.575-2.223-33.037-.196z"
            ></path>
            <path
                fill="url(#paint8_linear_0_34274)"
                d="M205.666 220.453c-12.979-1.802-17.737-1.46-31.342-.268l1.31 5.441s20.248-3.971 39.114-1.675c0 0-4.846-2.912-9.082-3.498z"
            ></path>
            <path
                fill="url(#paint9_linear_0_34274)"
                d="M302.384 248.161s-10.654-3.415-13.253 5.007c-2.477 8.03 21.562 10.19 21.562 10.19s-1.773-11.91-8.309-15.197z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M108.128 237.599a.784.784 0 00.181-.024c2.501-.757 4.606-3.39 7.049-6.443 3.561-4.455 7.601-9.506 14.186-10.762 12.632-2.413 31.777-4.079 31.967-4.098a.617.617 0 00.562-.67.606.606 0 00-.669-.561c-.191.014-19.403 1.695-32.095 4.113-7.034 1.343-11.406 6.809-14.923 11.206-2.311 2.892-4.309 5.383-6.439 6.033a.621.621 0 00-.415.772.62.62 0 00.591.439l.005-.005zM88.55 244.614c.229 0 .449-.127.556-.342 1.036-2.09 5.633-3.038 10.073-3.956 1.588-.328 3.234-.67 4.743-1.065a.624.624 0 00.445-.758.628.628 0 00-.757-.444c-1.48.386-3.107.723-4.68 1.05-4.953 1.021-9.628 1.988-10.933 4.621a.619.619 0 00.552.894z"
            ></path>
            <path
                fill="url(#paint10_linear_0_34274)"
                d="M141.998 289.204c.876-10.84-7.202-20.338-18.041-21.214-10.84-.876-20.338 7.202-21.214 18.042-.876 10.839 7.202 20.337 18.041 21.213 10.84.876 20.338-7.201 21.214-18.041z"
            ></path>
            <path
                fill="url(#paint11_linear_0_34274)"
                d="M134.722 287.743c-.181 6.937-5.95 12.413-12.886 12.237-6.937-.18-12.413-5.95-12.237-12.886.181-6.937 5.95-12.413 12.886-12.237 6.937.181 12.413 5.95 12.237 12.886z"
                opacity="0.57"
            ></path>
            <path
                fill="url(#paint12_linear_0_34274)"
                d="M281.969 291.293c2.69-10.538-3.671-21.26-14.209-23.95-10.537-2.69-21.26 3.672-23.95 14.209-2.689 10.537 3.672 21.26 14.21 23.95 10.537 2.69 21.26-3.672 23.949-14.209z"
            ></path>
            <path
                fill="url(#paint13_linear_0_34274)"
                d="M275.238 286.527c-.181 6.937-5.95 12.413-12.886 12.237-6.937-.181-12.413-5.95-12.237-12.886.181-6.937 5.95-12.413 12.886-12.237 6.937.181 12.413 5.95 12.237 12.886z"
                opacity="0.57"
            ></path>
            <path
                fill="#BDD0FB"
                d="M178.892 286.757h.063c.362 0 .645-.142.64-.499 0-.258-.161-.405-.381-.503-1.28-2.061-2.941-24.283-3.698-38.01a.638.638 0 00-.684-.596.663.663 0 00-.615.694c.005.098.542 9.624 1.309 19.174 1.563 19.442 2.525 19.74 3.366 19.74z"
            ></path>
            <path
                fill="url(#paint14_linear_0_34274)"
                d="M236.354 249.143h-13.385a4.298 4.298 0 00-4.299 4.298v.684a4.3 4.3 0 004.299 4.299h13.385a4.3 4.3 0 004.299-4.299v-.684a4.298 4.298 0 00-4.299-4.298z"
            ></path>
            <path
                fill="url(#paint15_linear_0_34274)"
                d="M334.019 215.358h4.856c.845 0 1.534.67 1.558 1.51l2.79 94.421-12.745-.351 3.541-95.575v-.005z"
            ></path>
            <path
                fill="url(#paint16_linear_0_34274)"
                d="M300.039 309.877l18.724-92.589a2.407 2.407 0 012.36-1.925h12.896l3.175 94.68-37.16-.161.005-.005z"
            ></path>
            <path
                fill="url(#paint17_linear_0_34274)"
                d="M337.199 324.752H84.49a2.116 2.116 0 01-2.115-2.115v-10.752c0-1.216.987-2.203 2.203-2.203H337.2v15.075-.005z"
            ></path>
            <path
                fill="url(#paint18_linear_0_34274)"
                d="M397.407 266.802l-11.89-43.315c-.298-1.099-1.158-1.29-2.125-1.29H339.53c-2.37 0-4.289 1.998-4.289 4.46v97.934h64.975l-2.814-57.789h.005z"
            ></path>
            <path
                fill="url(#paint19_linear_0_34274)"
                d="M401.671 304.206c-.361-.63-.952-.972-1.456-.948l-25.221 1.28a3.35 3.35 0 00-3.18 3.322l-.137 18.045 28.553 1.832c1.036 0 2.208-1.319 2.208-3.166v-17.962c0-.904-.4-1.768-.762-2.398l-.005-.005z"
            ></path>
            <path
                fill="url(#paint20_linear_0_34274)"
                d="M388.125 268.751l-7.186-34.737c-.249-1.212-1.143-2.13-2.164-2.13h-28.103c-.606 0-1.182.366-1.603.899-.42.527-.649 1.279-.63 2.017l.674 27.854c.03 1.309.821 2.413 1.876 2.619l34.615 6.834c.743.146 1.495-.171 2.003-.85.508-.679.703-1.617.518-2.511v.005z"
            ></path>
            <path
                fill="url(#paint21_linear_0_34274)"
                d="M388.12 231.195l-.42.049c-.713.083-1.358.484-1.783 1.104a2.892 2.892 0 00-.435 2.159l6.952 36.066c.224 1.177 2.745 1.924 4.313 2.022a.77.77 0 00.811-.713l.259-3.092c.024-.308 0-.616-.078-.909l-9.614-36.691-.005.005z"
            ></path>
            <path
                fill="url(#paint22_linear_0_34274)"
                d="M361.507 271.833h-8.91c-1.12 0-2.028.908-2.028 2.028v.366c0 1.12.908 2.027 2.028 2.027h8.91a2.027 2.027 0 002.027-2.027v-.366c0-1.12-.908-2.028-2.027-2.028z"
            ></path>
            <path
                fill="#fff"
                d="M338.782 296.493a.49.49 0 01-.488-.489v-52.157a.49.49 0 01.488-.488.49.49 0 01.489.488v52.157a.49.49 0 01-.489.489z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint23_linear_0_34274)"
                d="M397.66 308.51h-6.135a2.237 2.237 0 00-2.238 2.237v6.722a2.238 2.238 0 002.238 2.237h6.135a2.238 2.238 0 002.238-2.237v-6.722a2.237 2.237 0 00-2.238-2.237z"
            ></path>
            <path
                fill="#fff"
                d="M393.411 307.445v12.964h-1.593c-1.231 0-3.419-1.314-3.419-2.545v-7.352c0-1.231 2.183-3.067 3.419-3.067h1.593z"
                opacity="0.8"
            ></path>
            <path
                fill="url(#paint24_linear_0_34274)"
                d="M335.382 311.05H73.861l-.318-2.907 15.7-2.902 246.139.323v5.486z"
            ></path>
            <path
                fill="url(#paint25_linear_0_34274)"
                d="M363.891 348.41c11.849 0 21.455-9.606 21.455-21.455 0-11.849-9.606-21.455-21.455-21.455-11.849 0-21.455 9.606-21.455 21.455 0 11.849 9.606 21.455 21.455 21.455z"
            ></path>
            <path
                fill="url(#paint26_linear_0_34274)"
                d="M367.881 343.927c9.364-2.21 15.163-11.592 12.953-20.956-2.21-9.363-11.592-15.162-20.956-12.952-9.363 2.21-15.162 11.592-12.952 20.955 2.21 9.364 11.592 15.163 20.955 12.953z"
            ></path>
            <path
                fill="#fff"
                d="M378.521 333.452a.485.485 0 01-.449-.679 14.863 14.863 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938-2.555 0-5.075.655-7.288 1.895a.488.488 0 11-.479-.85 15.904 15.904 0 017.767-2.022c8.774 0 15.915 7.137 15.915 15.915 0 2.15-.42 4.231-1.25 6.194a.487.487 0 01-.45.298z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint27_linear_0_34274)"
                d="M371.653 328.775a7.991 7.991 0 10-15.556-3.671 7.99 7.99 0 005.942 9.613 7.991 7.991 0 009.614-5.942z"
            ></path>
            <path
                fill="url(#paint28_linear_0_34274)"
                d="M180.687 332.464c2.722-11.533-4.421-23.088-15.953-25.81-11.532-2.722-23.087 4.42-25.809 15.953-2.722 11.532 4.42 23.087 15.952 25.809 11.533 2.722 23.088-4.42 25.81-15.952z"
            ></path>
            <path
                fill="url(#paint29_linear_0_34274)"
                d="M163.799 344.519c9.364-2.21 15.163-11.592 12.953-20.955-2.21-9.363-11.592-15.162-20.956-12.952-9.363 2.21-15.162 11.592-12.952 20.955 2.21 9.363 11.592 15.162 20.955 12.952z"
            ></path>
            <path
                fill="#fff"
                d="M174.442 334.048a.485.485 0 01-.45-.679 14.87 14.87 0 001.173-5.813c0-8.236-6.703-14.938-14.939-14.938a14.93 14.93 0 00-7.288 1.895.488.488 0 01-.479-.85 15.907 15.907 0 017.767-2.022c8.774 0 15.916 7.137 15.916 15.915 0 2.149-.42 4.23-1.251 6.194a.487.487 0 01-.449.298z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint30_linear_0_34274)"
                d="M167.657 329.061a7.993 7.993 0 00-15.696-3.022 7.993 7.993 0 0015.696 3.022z"
            ></path>
            <path
                fill="url(#paint31_linear_0_34274)"
                d="M302.033 329.638c1.167-11.792-7.447-22.297-19.238-23.463-11.792-1.167-22.296 7.447-23.463 19.238-1.166 11.792 7.447 22.296 19.238 23.463 11.792 1.166 22.297-7.447 23.463-19.238z"
            ></path>
            <path
                fill="url(#paint32_linear_0_34274)"
                d="M283.988 344.664c9.448-1.819 15.631-10.953 13.812-20.4-1.819-9.447-10.952-15.63-20.4-13.811-9.447 1.819-15.63 10.952-13.811 20.399 1.819 9.447 10.952 15.631 20.399 13.812z"
            ></path>
            <path
                fill="#fff"
                d="M295.335 334.048a.484.484 0 01-.449-.679 14.888 14.888 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938a14.93 14.93 0 00-7.289 1.895.488.488 0 11-.478-.85 15.902 15.902 0 017.767-2.022c8.773 0 15.915 7.137 15.915 15.915 0 2.149-.42 4.23-1.251 6.194a.486.486 0 01-.449.298z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint33_linear_0_34274)"
                d="M288.548 329.064a7.992 7.992 0 00-6.337-9.359 7.99 7.99 0 00-9.358 6.336 7.992 7.992 0 0015.695 3.023z"
            ></path>
            <path
                fill="url(#paint34_linear_0_34274)"
                d="M131.613 332.471c2.722-11.533-4.42-23.088-15.952-25.81-11.533-2.722-23.088 4.421-25.81 15.953-2.722 11.532 4.42 23.087 15.953 25.809 11.532 2.722 23.088-4.42 25.809-15.952z"
            ></path>
            <path
                fill="url(#paint35_linear_0_34274)"
                d="M114.025 344.666c9.447-1.819 15.631-10.953 13.811-20.4-1.819-9.447-10.952-15.63-20.399-13.811-9.447 1.819-15.63 10.952-13.812 20.399 1.82 9.447 10.953 15.631 20.4 13.812z"
            ></path>
            <path
                fill="#fff"
                d="M125.368 334.048a.484.484 0 01-.449-.679 14.888 14.888 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938-2.555 0-5.076.654-7.294 1.895a.488.488 0 11-.478-.85 15.902 15.902 0 017.767-2.022c8.773 0 15.915 7.137 15.915 15.915 0 2.149-.42 4.23-1.251 6.194a.486.486 0 01-.449.298h.005z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint36_linear_0_34274)"
                d="M118.583 329.065a7.992 7.992 0 10-15.695-3.022 7.992 7.992 0 1015.695 3.022z"
            ></path>
            <path
                fill="url(#paint37_linear_0_34274)"
                d="M5.447 235.04c2.882-4.797 3.624-9.101 2.774-14.67-1.407-9.188-.312-19.418 5.545-26.975 5.554-7.171 15.549-7.811 21.65-14.21.044-.044.18-.254.386-.576a15.913 15.913 0 002.481-8.065c.596-18.006 13.693-17.796 19.907-14.382 9.838 5.408 7.679 15.5 7.679 15.5-2.745 2.936-12.55-3.322-12.55-3.322l-4.074 6.541a88.704 88.704 0 013.747 1.735c9.233 4.528 10.224 39.9 5.022 45.557-5.203 5.656-6.116 11.059-.87 20.316 5.247 9.257 2.213 21.348-25.7 31.376-4.518 1.627-11.328 1.798-15.793-.009C5.857 269.884.47 258.233.205 248.2c-.137-5.095 2.74-9.003 5.237-13.16h.005z"
            ></path>
            <path
                fill="#fff"
                d="M12.681 223.477a.122.122 0 01-.122-.112c-1.148-12.794 2.765-21.221 6.253-26.032 4.382-6.053 9.501-8.681 11.836-9.282 5.15-1.319 7.548-7.376 7.572-7.44a.121.121 0 01.156-.068.119.119 0 01.069.156c-.025.064-2.472 6.238-7.738 7.587-2.985.767-7.923 3.966-11.7 9.188-3.458 4.783-7.347 13.151-6.203 25.871a.122.122 0 01-.113.132h-.01zM17.24 268.399s-.03 0-.045-.01c-.112-.044-11.191-4.484-10.996-16.77 0-.068.054-.122.122-.122.069 0 .122.059.122.122-.19 12.115 10.733 16.497 10.845 16.541a.118.118 0 01.068.156.12.12 0 01-.112.078l-.005.005z"
            ></path>
            <path
                fill="url(#paint38_linear_0_34274)"
                d="M84.95 223.296s-12.086 14.474-24.254 2.721l-4.704 10.903s17.771 13.761 31.254-7.889l-2.296-5.735z"
            ></path>
            <path
                fill="url(#paint39_linear_0_34274)"
                d="M55.102 196.429c-3.355-1.006-13.12-2.863-22.412 5.711a5.751 5.751 0 00-1.656 5.735c2.496 9.188 9.081 36.329 3.307 48.077 0 0 10.176 11.216 21.274 2.174 0 0 4.978-21.704 11.504-31.234 4.504-6.58-7.18-24.704-10.136-29.08a3.463 3.463 0 00-1.876-1.383h-.005z"
            ></path>
            <path
                fill="url(#paint40_linear_0_34274)"
                d="M49.905 178.912s-6.77 13.257-7.958 19.344c0 0 5.105 3.195 10.786-.293 0 0 2.39-13.824 3.493-16.208l-6.321-2.843z"
            ></path>
            <path
                fill="url(#paint41_linear_0_34274)"
                d="M68.565 303.698c-.039.987 1.69 8.803 2.633 12.97a6.847 6.847 0 01-.737 4.924l-32.607 54.877a7.362 7.362 0 00-.855 2.135c-.596 2.574-1.837 8.886-1.192 14.63l1.685 3.503-7.293-1.656-1.588-19.589 2.066-1.26a9.81 9.81 0 003.967-4.646c2.95-7.161 10.268-25.392 12.159-34.277 2.144-10.098 13.355-18.299 13.355-18.299l-1.968-4.656 10.375-8.656z"
            ></path>
            <path
                fill="url(#paint42_linear_0_34274)"
                d="M22.09 388.339s3.937-6.247 4.401-8.675c.464-2.433 1.754-6.727 4.182-5.432 0 0 1.143 11.812.752 16.423-.396 4.616 5.217 4.465 5.217 4.465s1.549.215 2.677 1.348c.782.782.225 2.14-.88 2.208-1.836.117-4.752.151-7.815-.444a2.392 2.392 0 01-1.93-2.208l-.81-13.595-4.969 6.277-.83-.376.005.009z"
            ></path>
            <path
                fill="url(#paint43_linear_0_34274)"
                d="M49.09 312.437s-1.149 49.089-1.305 56.06c-.156 6.971 1.099 22.422 8.09 27.038l-3.044 2.252s-3.8-3.229-7.513-9.447c-4.172-6.986-5.432-8.261-5.432-8.261l1.382-2.833a6.202 6.202 0 00.503-3.996c-1.509-7.308-6.545-31.625-7.923-36.857-1.622-6.18-1.739-14.435 3.908-21.343 5.642-6.907 11.328-2.608 11.328-2.608l.005-.005z"
            ></path>
            <path
                fill="url(#paint44_linear_0_34274)"
                d="M42.636 400a.427.427 0 01-.43-.366c-.234-1.637-1.202-8.197-1.993-9.897-.909-1.944-3.874-10.137 0-10.83 0 0 9.633 14.068 11.48 15.969 1.846 1.895 4.181.664 4.181.664s1.803.533 3.16 2.267c.646.825.045 2.037-1.005 2.046l-6.488.064a4.56 4.56 0 01-4.279-2.877c-1.143-2.853-3.102-7.035-5.388-8.891l1.187 11.372a.436.436 0 01-.425.479z"
            ></path>
            <path
                fill="url(#paint45_linear_0_34274)"
                d="M57.144 252.831s-1.46 4.66.782 12.334l13.932 48.65a1.505 1.505 0 01-.943 1.831c-4.167 1.495-17.864 5.726-36.564 4.436a2.122 2.122 0 01-1.934-1.651c-1.231-5.545-5.437-24.469-6.302-28.357-3.297-14.816-6.492-28.905 9.707-38.567 7.464 3.199 13.941 3.195 21.322 1.324z"
            ></path>
            <path
                fill="url(#paint46_linear_0_34274)"
                d="M40.34 208.783s-2.804 40.076 23.086 19.945c0 0 3.825-3.61 6.585-4.049 1.485-.235 3.166-.396 4.397-.489.561-.044.825.684.361 1.007-.889.625-2.056 1.299-3.068 1.402-1.954.2.127 1.631-1.998 5.373s-5.163 2.33-5.163 2.33-29.666 30.38-35.592-22.608c-.21-9.857 9.277-9.335 11.387-2.911h.005z"
            ></path>
            <path
                fill="url(#paint47_linear_0_34274)"
                d="M92.897 213.336l-8.807-1.163c-1.05-.176-2.135.44-2.785 1.578l-5.793 12.808c-1.09 1.915-.313 4.45 1.45 4.744l7.074.908c.68.112 1.373-.313 1.754-1.079l7.835-15.642c.455-.904.073-2.027-.728-2.159v.005z"
            ></path>
            <path
                fill="url(#paint48_linear_0_34274)"
                d="M86.889 230.609s5.92-8.617 5.236-9.682c-.688-1.06-5.881-2.579-7.097-2.941-1.222-.356-3.513 7.46 1.866 12.618l-.005.005z"
            ></path>
            <path
                fill="url(#paint49_linear_0_34274)"
                d="M65.077 171.442s1.26 22.286-8.113 22.598c-9.375.313-10.288-15.534-10.288-15.534s2.77-10.009 7.23-11.177c4.464-1.167 11.167 4.113 11.167 4.113h.004z"
            ></path>
            <path
                fill="url(#paint50_linear_0_34274)"
                d="M62.322 164.564s4.284 4.382 3.547 7.108c-.738 2.726-9.926-.127-12.188-1.412l-7.591 8.08s.234-11.968 5.47-15.651c5.237-3.684 10.762 1.88 10.762 1.88v-.005z"
            ></path>
            <path
                fill="url(#paint51_linear_0_34274)"
                d="M49.519 178.721s-1.143-7.645-4.88-5.495c-3.737 2.149.273 8.074 3.195 7.703l1.685-2.208z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear_0_34274"
                    x1="14.171"
                    x2="32.334"
                    y1="78.555"
                    y2="78.555"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_34274"
                    x1="124.2"
                    x2="122.735"
                    y1="43.906"
                    y2="93.733"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_34274"
                    x1="66.103"
                    x2="82.255"
                    y1="268.987"
                    y2="272.718"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2B3582"></stop>
                    <stop offset="1" stopColor="#150E42"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_34274"
                    x1="205.667"
                    x2="214.787"
                    y1="214.801"
                    y2="167.906"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_34274"
                    x1="131.986"
                    x2="117.009"
                    y1="209.628"
                    y2="233.403"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_34274"
                    x1="294.646"
                    x2="294.646"
                    y1="193.649"
                    y2="236.315"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_34274"
                    x1="167.289"
                    x2="127.688"
                    y1="174.615"
                    y2="276.036"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_34274"
                    x1="223.828"
                    x2="184.219"
                    y1="196.323"
                    y2="297.77"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_34274"
                    x1="369.183"
                    x2="396.71"
                    y1="-294.708"
                    y2="-376.114"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_34274"
                    x1="331.293"
                    x2="370.011"
                    y1="207.757"
                    y2="145.806"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_34274"
                    x1="114.863"
                    x2="167.219"
                    y1="293.624"
                    y2="253.216"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_34274"
                    x1="109.671"
                    x2="134.79"
                    y1="287.02"
                    y2="287.669"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_34274"
                    x1="255.355"
                    x2="307.718"
                    y1="292.215"
                    y2="251.817"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_34274"
                    x1="250.182"
                    x2="275.302"
                    y1="285.808"
                    y2="286.457"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_34274"
                    x1="275.35"
                    x2="258.741"
                    y1="213.473"
                    y2="228.127"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_34274"
                    x1="393.215"
                    x2="316.771"
                    y1="234.967"
                    y2="274.676"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_34274"
                    x1="303.727"
                    x2="306.658"
                    y1="29.788"
                    y2="81.075"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_34274"
                    x1="209.233"
                    x2="211.172"
                    y1="346.139"
                    y2="248.371"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_34274"
                    x1="381.965"
                    x2="309.37"
                    y1="253.3"
                    y2="363.641"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_34274"
                    x1="387.69"
                    x2="384.789"
                    y1="295.642"
                    y2="400.904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_34274"
                    x1="360.085"
                    x2="414.865"
                    y1="251.453"
                    y2="252.831"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_34274"
                    x1="388.51"
                    x2="409.011"
                    y1="251.844"
                    y2="253.556"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_34274"
                    x1="379.342"
                    x2="344.331"
                    y1="262.537"
                    y2="280.607"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_34274"
                    x1="387.338"
                    x2="394.114"
                    y1="331.449"
                    y2="315.256"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_34274"
                    x1="189.004"
                    x2="191.935"
                    y1="36.339"
                    y2="87.631"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_34274"
                    x1="342.436"
                    x2="385.341"
                    y1="326.955"
                    y2="326.955"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_34274"
                    x1="359.619"
                    x2="366.878"
                    y1="277.401"
                    y2="361.608"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_34274"
                    x1="371.737"
                    x2="349.931"
                    y1="314.175"
                    y2="349.904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_34274"
                    x1="138.337"
                    x2="181.241"
                    y1="327.663"
                    y2="327.663"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_34274"
                    x1="156.993"
                    x2="164.252"
                    y1="294.862"
                    y2="379.073"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_34274"
                    x1="167.679"
                    x2="145.867"
                    y1="314.682"
                    y2="350.411"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_34274"
                    x1="259.202"
                    x2="302.107"
                    y1="327.783"
                    y2="327.783"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_34274"
                    x1="276.989"
                    x2="284.248"
                    y1="284.517"
                    y2="368.724"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_34274"
                    x1="288.567"
                    x2="266.761"
                    y1="314.687"
                    y2="350.415"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_34274"
                    x1="89.263"
                    x2="132.168"
                    y1="327.664"
                    y2="327.664"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_34274"
                    x1="108.28"
                    x2="115.539"
                    y1="299.064"
                    y2="383.276"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_34274"
                    x1="118.607"
                    x2="96.796"
                    y1="314.685"
                    y2="350.413"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_34274"
                    x1="75.116"
                    x2="56.265"
                    y1="125.504"
                    y2="172.449"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_34274"
                    x1="78.331"
                    x2="67.574"
                    y1="208.143"
                    y2="247.941"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_34274"
                    x1="144.986"
                    x2="125.207"
                    y1="103.092"
                    y2="128.005"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint40_linear_0_34274"
                    x1="53.901"
                    x2="48.381"
                    y1="207.143"
                    y2="188.702"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint41_linear_0_34274"
                    x1="106.224"
                    x2="85.218"
                    y1="420.766"
                    y2="394.387"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint42_linear_0_34274"
                    x1="21.952"
                    x2="39.459"
                    y1="386.617"
                    y2="386.452"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint43_linear_0_34274"
                    x1="40.291"
                    x2="91.798"
                    y1="337.443"
                    y2="445.767"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint44_linear_0_34274"
                    x1="38.214"
                    x2="59.087"
                    y1="389.625"
                    y2="389.428"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint45_linear_0_34274"
                    x1="79.576"
                    x2="36.246"
                    y1="245.064"
                    y2="305.559"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint46_linear_0_34274"
                    x1="57.657"
                    x2="103.713"
                    y1="223.536"
                    y2="223.536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint47_linear_0_34274"
                    x1="80.896"
                    x2="89.248"
                    y1="214.646"
                    y2="224.24"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint48_linear_0_34274"
                    x1="90.215"
                    x2="84.544"
                    y1="212.354"
                    y2="233.325"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint49_linear_0_34274"
                    x1="63.977"
                    x2="31.856"
                    y1="175.416"
                    y2="196.193"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint50_linear_0_34274"
                    x1="74.921"
                    x2="56.021"
                    y1="124.996"
                    y2="172.058"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint51_linear_0_34274"
                    x1="59.462"
                    x2="27.342"
                    y1="168.435"
                    y2="189.212"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
            </defs>
        </svg>
    );
}

export default MainImg;
